namespace $.$$ {

	export class $shm_agent_message_chart extends $.$shm_agent_message_chart {

		height_style() {
			return `${ Math.max( 240, Math.min( 600, this.height() ) ) }px`
		}

	}

}
